import { Component, OnInit } from '@angular/core';
import { PsaService } from '../psa.service';

@Component({
  selector: 'app-disclaimer-psa',
  templateUrl: './disclaimer-psa.component.html',
  styleUrls: ['./disclaimer-psa.component.css']
})
export class DisclaimerPsaComponent implements OnInit {

  readConfirm:boolean
  agreeConfirm:boolean
  brownField:boolean
  greenField:boolean

  constructor(private psaService:PsaService) { 


    this.psaService.onDevelopmentChange.subscribe((x) => {
  

      if (this.psaService.applicationData.planType === "BrownField") {
        this.brownField = true;
        this.greenField = false;
      }
      if (this.psaService.applicationData.planType === "GreenField") {
        this.greenField = true;
        this.brownField = false;
      }

    this.readConfirm=false
    this.agreeConfirm=false

    });

  }

  ngOnInit() {

  }

  get invalid(): boolean {
    if(!this.readConfirm || !this.agreeConfirm)
    return true
  }

}



// WEBPACK FOOTER //
// ./src/app/create-application/psa-form/disclaimer-psa/disclaimer-psa.component.ts